import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import {
    TableContainer, Paper, Table, TableHead, TableRow,
    TableCell, TableBody, TablePagination,
    IconButton, Dialog, DialogTitle, DialogContent,
    DialogContentText, DialogActions
} from '@mui/material';

import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';

import Button from '@mui/material/Button';
import Select from 'react-select'; // Import react-select
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function PRIndex() {
    // const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [type, setType] = useState("0");
    // const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [from, setFromDate] = useState(() => {
        const today = new Date();
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - 30); // Set from date to 30 days before today
        return pastDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    });

    const [to, setToDate] = useState(() => {
        return new Date().toISOString().split("T")[0]; // Set to current date
    });

    const handleFromDateChange = (e) => {
        const newFromDate = e.target.value; // Expected format: "YYYY-MM-DD"
        setFromDate(newFromDate);

        // Convert to Date object
        const fromDateObj = new Date(newFromDate);
        const toDateObj = new Date(to); // 'to' should be in "YYYY-MM-DD" format

        // Ensure "to" is not earlier than "from"
        if (fromDateObj > toDateObj) {
            setToDate(newFromDate);
        }
    };

    const handleToDateChange = (e) => {
        const newToDate = e.target.value; // Expected format: "YYYY-MM-DD"

        // Convert to Date object
        const fromDateObj = new Date(from); // 'from' should be in "YYYY-MM-DD" format
        const toDateObj = new Date(newToDate);

        // Validate "to" date is not earlier than "from"
        if (toDateObj < fromDateObj) {
            alert("To date cannot be earlier than From date.");
            return;
        }

        setToDate(newToDate);
    };
    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        // inputRef.current.focus();
    }, [isAuthenticated, clubId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };
    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const handleOptionChange = (event) => {
        setType(event.target.value);
        //fetchtableData();

    };

    useEffect(() => {
        fetchtableData();
    }, []);


    const fetchtableData = async () => {
        setIsLoading(true); // Show loading indicator
        setData([]); // Clear previous data
        setRowsPerPage(10); // Reset rows per page to default
        setPage(0); // Reset to the first page
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/${clubId}/${branchId}/${from}/${to}/${type}`, token);
            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Payment & Receipt Details:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const handleDelete = async () => {
        deleteData('PaymentAndReceiptApi', `${deleteMember}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteMember(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (memberId) => {
        activateData('PaymentAndReceiptApi', `${memberId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (memberId) => {
        setDeleteMember(memberId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteMember(null);
        setConfirmDialogOpen(false);
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchtableData();
    }
    const [isFocused, setIsFocused] = useState(false);
    // const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}>PAYMENTS & RECEIPT</h6>
            </div>


            <div className="w-full flex flex-wrap items-center gap-2 mb-3" style={{ marginTop: '-20px' }}>
                <div className="flex flex-col">
                    <label
                        style={{ color: 'Black', fontSize: '14px', marginRight: '8px' }}
                        htmlFor="ledgerName"
                    >From</label>
                    <input
                        type="date"
                        value={from}
                        onChange={handleFromDateChange}
                        className="border rounded px-2 py-1 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                    />
                </div>

                <div className="flex flex-col">
                    <label
                        style={{ color: 'Black', fontSize: '14px', marginRight: '8px' }}
                        htmlFor="ledgerName"
                    >To</label>
                    <input
                        type="date"
                        value={to}
                        onChange={handleToDateChange}
                        className="border rounded px-2 py-1 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                    />
                </div>
                <div className='w-1/6' style={{ marginRight: '10px' }}>
                    <label
                        style={{ color: 'Black', fontSize: '14px', marginRight: '8px' }}
                        htmlFor="ledgerName"
                    >Select Type</label>
                    <select
                        name="type"
                        value={type}
                        onChange={handleOptionChange}
                        className="form-select block w-full border-2 border-[#234C6A] py-1 px-2 rounded text-gray-700 "
                    >
                        <option value="0">All</option>
                        <option value="1">Payment</option>
                        <option value="2">Receipt</option>
                    </select>

                </div>

                <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    className="border rounded px-3 py-1 transition-all focus:ring-1 focus:ring-cyan-500"
                    style={{ width: isFocused ? '200px' : '120px', transition: 'width 0.3s ease-in-out', marginTop: '20px' }}
                />

                <Button style={{ backgroundColor: '#7D0A0A', color: 'white', fontWeight: 'bold', marginTop: '20px', height: '25px' }}
                    component={Link}
                    to="/PRCreate"
                    className="bg-cyan-700 font-bold px-3 py-1 rounded flex items-center gap-1"
                    onClick={handleFormSubmit}
                >
                    {isLoading ? <CircularProgress size={16} color="inherit" /> : "Find"}
                </Button>

                <Button style={{ backgroundColor: '#27391C', color: 'white', fontWeight: 'bold', marginTop: '20px', height: '25px' }}
                    component={Link}
                    to="/PRCreate"
                    className="bg-green-600  font-bold px-3 py-1 rounded flex items-center gap-1"
                >
                    CREATE
                </Button>

            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Bill Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Head</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textAlign: 'right', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1p  x solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textAlign: 'right', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <CircularProgress size={24} />
                                    </TableCell>
                                </TableRow>
                            ) : (

                                paginatedData.map((datas, index) => (
                                    <TableRow
                                        key={datas.id}
                                        className={datas.isActive ? '' : 'inactiveRow'}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd', // Alternate row background colors
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{datas.billNo}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{formatDateForInput(datas.billDate)}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{datas.head}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{datas.description}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px', textAlign: 'right' }}>
                                            {datas.amount != null ? datas.amount.toFixed(2) : '-'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px', textAlign: 'right' }}>
                                            <Link to={`/PaymentAndReceiptEdit/${datas.id}/${datas.eventId}/${1}`}>
                                                <IconButton>
                                                    <EditIcon style={{ fontsize: '10px', color: 'blue' }} />
                                                </IconButton>
                                            </Link>

                                            <IconButton onClick={() => (datas.isActive ? openConfirmDialog(datas.id) : handleActivate(datas.id))}>
                                                {datas.isActive ? <DeleteIcon style={{ fontsize: '10px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '10px' }} />}
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}

                            {/* Calculate total amount */}
                            <TableRow sx={{ backgroundColor: '#15abd2' }}>
                                <TableCell colSpan={5} sx={{ color: 'white', fontWeight: 'bold', textAlign: 'right', padding: '8px', textTransform: 'uppercase' }}>
                                    Grand Total
                                </TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'right', padding: '8px' }}>
                                    {filteredData.reduce((sum, item) => sum + (item.amount || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell />
                            </TableRow>
                        </TableBody>

                    </Table>
                  
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 250, 350]} 
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />





                    {/* Dialog for delete confirmation */}
                    <Dialog
                        open={confirmDialogOpen}
                        onClose={closeConfirmDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete this record?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <button
                                onClick={closeConfirmDialog}
                                style={{
                                    backgroundColor: '#dc3545',
                                    color: '#ffffff',
                                    border: '1px solid #dc3545',
                                    borderRadius: '4px',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    marginRight: '8px',
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                style={{
                                    backgroundColor: '#28a745',
                                    color: '#ffffff',
                                    border: '1px solid #28a745',
                                    borderRadius: '4px',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                }}
                            >
                                Confirm
                            </button>
                        </DialogActions>
                    </Dialog>
                </TableContainer>
            </div>
        </div>
    );
}

export default PRIndex;




